import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { WhatsAppButton } from "../components/WhatsAppButton";
import { CookieConsent } from "../components/CookieConsent";
import { TrustBar } from "../components/TrustBar";
import { CtaBanner } from "../components/CtaBanner";
import { Hero } from "../components/sections/Hero";
import { useEffect } from "react";
import api from "../lib/api";
import { TrackingWidget } from "../components/sections/TrackingWidget";
import { AutoSales } from "../components/sections/AutoSales";
import { HowItWorks } from "../components/sections/HowItWorks";
import { Gallery } from "../components/sections/Gallery";
import { Testimonials } from "../components/sections/Testimonials";
import { QuoteForm } from "../components/sections/QuoteForm";
import { useSeo } from "../hooks/useSeo";

export default function Home() {
  useSeo({
    title: "R.O.K Motors – Towing & Shipping | Cars & Cargo USA to Ghana",
    description: "R.O.K Motors ships vehicles, containers and cargo from the USA to Ghana. Reliable, affordable and secure shipping to Tema Port. Get a free quote and track your shipment online.",
    path: "/",
    keywords: "ship car to Ghana, USA to Ghana shipping, container shipping Ghana, vehicle shipping Tema, cargo shipping, R.O.K Motors",
  });
  useEffect(() => {
    let vid = localStorage.getItem("rok_visitor_id");
    if (!vid) {
      vid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());
      localStorage.setItem("rok_visitor_id", vid);
    }
    api.post("/analytics/visit", { visitor_id: vid, path: "/", referrer: document.referrer || null }).catch(() => {});
  }, []);

  return (
    <div className="App bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TrackingWidget />
        <TrustBar />
        <HowItWorks />
        <AutoSales />
        <Gallery />
        <Testimonials />
        <QuoteForm />
        <CtaBanner />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
}
